import styled from "styled-components";
import OriginalSideNav, { Nav } from "@trendmicro/react-sidenav";
import { FROSTED_BLACK, LIGHT_GRAY, LIGHT_BLUE, BLACK } from "@shape/reef-shared";

// @ts-ignore
export const SideNav = styled(OriginalSideNav)`
  background-color: ${BLACK};
  position: fixed;

  && > [class*="sidenav-toggle--"] {
    width: 72px;
    > [class*="icon-bar--"] {
      background-color: ${LIGHT_BLUE};
    }
  }
`;

// @ts-ignore
export const NavbarContent = styled(Nav)<{ expanded: boolean }>`
  display: flex;
  flex-direction: column;
  height: calc(100% - 64px);

  && > [class*="sidenav-navitem--"],
  && > [class*="sidenav-navitem--"]:hover {
    height: ${({ expanded }) => (!expanded ? "72px" : "50px")};

    > [class*="sidenav---navitem--"] {
      height: ${({ expanded }) => (!expanded ? "72px" : "50px")};
    }
  }

  &&[class*="expanded--"] {
    [class*="sidenav-subnav--"] {
      > [class*="sidenav-subnavitem--"],
      > [class*="sidenav-subnavitem--"]:hover {
        > [class*="navitem--"] {
          color: ${LIGHT_GRAY};
        }
      }
      > [class*="sidenav-nav-text--"] {
        &,
        > * {
          color: ${LIGHT_GRAY};
        }
      }
    }
  }

  && > [class*="sidenav-navitem--"]:hover {
    > [class*="navitem--"] {
      cursor: pointer;
      background-color: ${FROSTED_BLACK};
    }
  }

  && > [class*="sidenav-navitem--"],
  && > [class*="sidenav-navitem--"]:hover {
    > [class*="navitem--"] {
      [class*="navicon--"] {
        &,
        > * {
          color: ${LIGHT_GRAY};
        }
      }
    }
  }

  && > [class*="sidenav-navitem--"][class*="highlighted--"] {
    &,
    > * {
      background-color: ${FROSTED_BLACK};
    }
  }

  && > [class*="sidenav-navitem--"][class*="highlighted--"],
  && > [class*="sidenav-navitem--"][class*="highlighted--"]:hover {
    > [class*="navitem--"] {
      [class*="navicon--"],
      [class*="navtext--"] {
        &,
        > * {
          color: ${LIGHT_BLUE};
          background-color: ${FROSTED_BLACK};
        }
      }
    }
  }

  && > [class*="sidenav-navitem--"],
  && > [class*="sidenav-navitem--"]:hover {
    [class*="navtext--"] {
      &,
      > * {
        color: ${LIGHT_GRAY};
        background-color: ${FROSTED_BLACK};
      }
    }
  }
`;

export const NavItemContainer = styled.div<{ expanded: boolean }>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 72px;
  height: ${({ expanded }) => (!expanded ? "72px" : "50px")};
  max-height: 72px;
`;

export const NavItemIcon = styled.span`
  line-height: 18px;
  font-size: 18px;
  padding-block: 6px;
`;

export const NavItemText = styled.span`
  line-height: 14px;
  font-size: 12px;
  max-width: 72px;
  white-space: pre-line;
  padding-inline: 8px;
`;

export const Spacer = styled.div`
  flex-grow: 1;
`;

export { NavItem, NavIcon, NavText } from "@trendmicro/react-sidenav";
